import React, { useState } from 'react';

import { ActionIcon, InfoIcon } from 'components/Icon';

interface Props
{
  tip?: string,
}
const InlineHelp: React.FC<Props> = ({tip, children}) =>
{
  const [visible, setVisible] = useState(false);

  return (
    <ActionIcon action={() => setVisible(prev => !prev)} tip={tip} className={['inline-help', visible ? 'visible' : ''].join(' ')}>
      <InfoIcon />
      <div className="help-text">{children}</div>
    </ActionIcon>
  );
};

export default InlineHelp;